import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import SidebarAdmin from './SidebarAdmin'
import Header from './Header'
import SidebarTecnico from './SidebarTecnico'
import { Context } from '../context/UserContext'
// import Footer from './Footer'
import SidebarWarehouse from './SidebarWarehouse';
import SidebarVivo from './SidebarVivo';
// import SidebarEntregador from './SideBarEntregador'
import SidebarReportReader from './SidebarReportReader'
import SidebarUser from './SidebarUser'
import { ehAdmin } from '../utils/roles'

export default function Layout() {

    const { user, authenticated } = useContext(Context)
    
    return (
        <div className='flex flex-row'>
            <div className='flex-none min-h-screen w-fit'>
                {/* SidebarAdmin é exclusivo da role 'admin' — é o menu que tem
                    Admin, Users e Documentação. Qualquer outra role cai no
                    SidebarUser, que é o menu da operação. Antes o SidebarAdmin
                    era o default, então todo 'user' enxergava o menu de admin. */}
                { user?.role === 'tecnico'
                    ? <SidebarTecnico />
                    // : user?.role === 'warehouse'
                    //     ? (window.innerWidth <= 600
                    //         ? null
                    //         : <SidebarWarehouse />)
                    : user?.role === 'warehouse'
                    ? <SidebarWarehouse />
                    : user?.role === 'vivogestao'
                    ? <SidebarVivo />
                    : user?.role === 'report-reader'
                    ? <SidebarReportReader />
                    : user?.role === 'entregador'
                    // ? <SidebarEntregador />
                    ? null // Temporariamente desativado
                    : ehAdmin(user)
                    ? <SidebarAdmin />
                    : <SidebarUser />
                }
            </div>
            <div className='w-full flex flex-col items-center'>
                <div className='w-full h-20'><Header /></div>
                <div className='w-full h-full flex justify-start items-start'>{<Outlet context={{ user, authenticated }}/>}</div>
                {/* <div className='w-full h-fit flex justify-center items-center mb-8'>
                    <Footer />
                </div> */}
            </div>
            
        </div>
    )
}
